module.exports = __webpack_public_path__ + "static/img/sence-2-map.0e308e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sence-2-map.png
// module id = mlkQ
// module chunks = 1